(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-correction-top-win.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-correction-top-win.js');

'use strict';

const {
  CONSTANTS: {
    CORRECTION_STEP
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
function getCorrectionStartAndTopWinHandler() {
  let eventHandlers = {};
  let distributionArray = [];
  let isSelfService = false;
  let result;
  let tlTopWinDraw;
  let tlTopWinStart;
  let tlTopWinStartBouncingPin;
  let tlTopWinStartRotate;
  let tlStartShow;
  let tlStartHide;
  return {
    timeline_StartContentShow() {
      tlStartShow = gsap.timeline();
      const animateElement = (selector, immediateOpacity, animateOpacity) => {
        const element = document.querySelector(selector);
        if (!element) {
          return;
        }
        tlStartShow.set(selector, {
          opacity: immediateOpacity
        });
        if (animateOpacity !== null) {
          tlStartShow.to(selector, {
            opacity: animateOpacity,
            duration: 1,
            ease: 'power1.out'
          }, '<');
        }
      };
      animateElement('.gsap-draw-start-content', isSelfService ? 1 : 0, isSelfService ? null : 1);
      animateElement('.gsap-draw-start', isSelfService ? 1 : 0, isSelfService ? null : 1);
      tlStartShow.play();
    },
    timeline_StartContentHide() {
      tlStartHide = gsap.timeline({
        paused: true
      });

      if (productMapping.isLyckoplatsenPrimary(result.productId)) {
        if (document.querySelector('.gsap-draw-start-content')) {
          tlStartHide.to('.gsap-draw-start-content', {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out'
          }, '>');
          tlStartHide.set('.gsap-draw-start-content', {
            zIndex: -1
          });
        }
        if (document.querySelector('.gsap-draw-start-primary-text')) {
          tlStartHide.to('.gsap-draw-start-primary-text', {
            opacity: 1,
            duration: 0.5,
            ease: 'power1.out'
          }, '>');
        }
      }

      if (productMapping.isLyckoplatsenSecondary(result.productId)) {
        tlStartHide.to('.gsap-start-secondary', {
          opacity: 1,
          duration: 0.5,
          ease: 'power1.out'
        }, '>');
      }
      return tlStartHide;
    },
    timeline_TopWinPinBounce() {
      if (productMapping.isLyckoplatsenSecondary(result.productId)) {
        return;
      }

      tlTopWinStartBouncingPin = gsap.timeline({
        paused: true,
        repeat: -1
      });
      if (document.querySelector('.gsap-draw-wheel-pin')) {
        tlTopWinStartBouncingPin.set('.gsap-draw-wheel-pin', {
          rotate: -58
        });
        tlTopWinStartBouncingPin.to('.gsap-draw-wheel-pin', {
          rotate: -24,
          duration: 0.12,
          ease: 'none'
        }, '>');
        tlTopWinStartBouncingPin.to('.gsap-draw-wheel-pin', {
          rotate: -58,
          duration: 0.38,
          ease: 'sine.out'
        }, '>');
      }
      return tlTopWinStartBouncingPin;
    },
    timeline_TopWinRotate() {
      if (productMapping.isLyckoplatsenSecondary(result.productId)) {
        return;
      }
      tlTopWinStartRotate = gsap.timeline({
        paused: true
      });

      if (document.querySelector('.gsap-draw-wheel-wrapper')) {
        gsap.set('.gsap-draw-wheel-wrapper', {
          opacity: 1
        });
        tlTopWinStartRotate.to('.gsap-draw-wheel-wrapper', {
          opacity: 1,
          duration: 2,
          ease: 'power1.out'
        }, '<');
      }
      if (document.querySelector('.gsap-draw-wheel')) {
        tlTopWinStartRotate.to('.gsap-draw-wheel', {
          rotation: '+=360',
          duration: 20,
          ease: 'none',
          repeat: -1
        }, '<');
      }
      return tlTopWinStartRotate;
    },
    animatePrimaryTopWinSpin() {
      if (productMapping.isLyckoplatsenSecondary(result.productId)) {
        return;
      }
      if (!Array.isArray(distributionArray)) {
        return;
      }
      const winPosition = distributionArray.findIndex(_ref => {
        let {
          isWin
        } = _ref;
        return isWin;
      });
      const tl = gsap.timeline();
      const spinDuration = 9;
      const currentRotation = gsap.getProperty('.gsap-draw-wheel', 'rotation');
      const remainingRotation = Math.round(1440 - 9 * (winPosition - 1) - currentRotation % 360) + svsRandom.getRandomInt(-3, 4);
      if (document.querySelector('.gsap-draw-wheel')) {
        tl.set('.gsap-draw-wheel', {
          rotation: '0'
        });
        tl.to('.gsap-draw-wheel', {
          rotation: "+=".concat(remainingRotation),
          duration: spinDuration,
          ease: 'power4.out'
        }, '<');
      }
      if (document.querySelector('.gsap-draw-wheel-pin')) {
        tl.to('.gsap-draw-wheel-pin', {
          rotation: -52,
          duration: 0.2,
          ease: 'sine.out'
        }, '<');
        tl.to('.gsap-draw-wheel-pin', {
          rotation: 0,
          duration: 0.25,
          ease: 'back(4)'
        }, '-=1.75');
      }
      if (document.querySelector('.top')) {
        tl.to('.top', {
          opacity: 0,
          duration: 1,
          top: '-15%',
          ease: 'power1.out'
        }, '>+1');
      }
      if (document.querySelector('.bottom')) {
        tl.to('.bottom', {
          opacity: 0,
          top: '50%',
          duration: 1,
          ease: 'power1.out'
        }, '<');
      }
      if (document.querySelector('.gsap-top-win')) {
        tl.to('.gsap-top-win', {
          opacity: 0,
          top: '-140px',
          duration: 1,
          ease: 'power1.out'
        }, '<');
      }
      if (document.querySelector('.gsap-start-primary')) {
        tl.to('.gsap-start-primary', {
          opacity: 0,
          duration: 0.375,
          ease: 'power1.out'
        }, '<');
      }
      tlTopWinDraw.add(tl, '>');
    },

    initiateDrawStartAndTopWinExperience(mapResult, resultDistributionArray, selfService) {
      let evtHandlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      Object.assign(eventHandlers, evtHandlers);

      result = mapResult;
      isSelfService = selfService;
      distributionArray = resultDistributionArray;

      tlTopWinDraw = gsap.timeline({
        paused: true,
        onComplete: () => {
          eventHandlers.automatedStepUpdate(CORRECTION_STEP.PLACE);
        }
      });

      if (document.querySelector('.gsap-top-win')) {
        tlTopWinDraw.set('.gsap-top-win', {
          opacity: 0,
          top: '-140px'
        });
      }
      if (document.querySelector('.gsap-draw-start-primary-text')) {
        tlTopWinDraw.set('.gsap-draw-start-primary-text', {
          opacity: 0
        });
      }

      this.timeline_StartContentShow();
      this.timeline_StartContentHide();
      this.timeline_TopWinPinBounce();
      this.timeline_TopWinRotate();

      this.animatePrimaryTopWinSpin();
      if (tlTopWinStartBouncingPin) {
        var _tlTopWinStartBouncin;
        (_tlTopWinStartBouncin = tlTopWinStartBouncingPin) === null || _tlTopWinStartBouncin === void 0 || _tlTopWinStartBouncin.play();
      }
      if (tlTopWinStartRotate) {
        var _tlTopWinStartRotate;
        (_tlTopWinStartRotate = tlTopWinStartRotate) === null || _tlTopWinStartRotate === void 0 || _tlTopWinStartRotate.play();
      }
    },
    tlTopWinPlay() {
      var _tlTopWinStart, _tlTopWinStartBouncin2, _tlTopWinStartRotate2, _tlStartHide;
      (_tlTopWinStart = tlTopWinStart) === null || _tlTopWinStart === void 0 || _tlTopWinStart.progress(1);
      (_tlTopWinStartBouncin2 = tlTopWinStartBouncingPin) === null || _tlTopWinStartBouncin2 === void 0 || _tlTopWinStartBouncin2.pause();
      (_tlTopWinStartRotate2 = tlTopWinStartRotate) === null || _tlTopWinStartRotate2 === void 0 || _tlTopWinStartRotate2.pause();
      (_tlStartHide = tlStartHide) === null || _tlStartHide === void 0 || _tlStartHide.play();
      if (productMapping.isLyckoplatsenPrimary(result.productId)) {
        var _tlTopWinDraw;
        (_tlTopWinDraw = tlTopWinDraw) === null || _tlTopWinDraw === void 0 || _tlTopWinDraw.play();
      }
    },
    tlTopWinPause() {
      var _tlTopWinDraw2;
      (_tlTopWinDraw2 = tlTopWinDraw) === null || _tlTopWinDraw2 === void 0 || _tlTopWinDraw2.pause();
    },
    tlTopWinKillAndRemove() {
      var _tlTopWinDraw3, _tlTopWinDraw4, _tlTopWinDraw5, _tlTopWinStart2, _tlTopWinStart3, _tlTopWinStartBouncin3, _tlTopWinStartBouncin4, _tlTopWinStartRotate3, _tlTopWinStartRotate4, _tlStartShow, _tlStartShow2, _tlStartHide2, _tlStartHide3;
      (_tlTopWinDraw3 = tlTopWinDraw) === null || _tlTopWinDraw3 === void 0 || _tlTopWinDraw3.eventCallback('onComplete', null);
      (_tlTopWinDraw4 = tlTopWinDraw) === null || _tlTopWinDraw4 === void 0 || _tlTopWinDraw4.clear();
      (_tlTopWinDraw5 = tlTopWinDraw) === null || _tlTopWinDraw5 === void 0 || _tlTopWinDraw5.kill();
      (_tlTopWinStart2 = tlTopWinStart) === null || _tlTopWinStart2 === void 0 || _tlTopWinStart2.clear();
      (_tlTopWinStart3 = tlTopWinStart) === null || _tlTopWinStart3 === void 0 || _tlTopWinStart3.kill();
      (_tlTopWinStartBouncin3 = tlTopWinStartBouncingPin) === null || _tlTopWinStartBouncin3 === void 0 || _tlTopWinStartBouncin3.clear();
      (_tlTopWinStartBouncin4 = tlTopWinStartBouncingPin) === null || _tlTopWinStartBouncin4 === void 0 || _tlTopWinStartBouncin4.kill();
      (_tlTopWinStartRotate3 = tlTopWinStartRotate) === null || _tlTopWinStartRotate3 === void 0 || _tlTopWinStartRotate3.clear();
      (_tlTopWinStartRotate4 = tlTopWinStartRotate) === null || _tlTopWinStartRotate4 === void 0 || _tlTopWinStartRotate4.kill();
      (_tlStartShow = tlStartShow) === null || _tlStartShow === void 0 || _tlStartShow.clear();
      (_tlStartShow2 = tlStartShow) === null || _tlStartShow2 === void 0 || _tlStartShow2.kill();
      (_tlStartHide2 = tlStartHide) === null || _tlStartHide2 === void 0 || _tlStartHide2.clear();
      (_tlStartHide3 = tlStartHide) === null || _tlStartHide3 === void 0 || _tlStartHide3.kill();
      tlTopWinDraw = null;
      tlTopWinStart = null;
      tlTopWinStartBouncingPin = null;
      tlTopWinStartRotate = null;
      tlStartShow = null;
      tlStartHide = null;
      eventHandlers = {};
      distributionArray = [];

      gsap.globalTimeline.clear();
      gsap.globalTimeline.kill();
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getCorrectionStartAndTopWinHandler
});

 })(window);